import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot} from "@angular/router";
import {userHandlingStore} from "../../dashboard-page/components/user-handling/store/user-handling.store";
import {inject} from "@angular/core";


export const userHandlingGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> => {
        const userHandling = inject(userHandlingStore);
        const userId = parseInt(route.paramMap.get('id'));
        if(userId && !isNaN(userId)){ return await userHandling.fetchUser(userId) !== undefined }
        return true;
}